import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscDataSourceLayoutAnalyticIds = {
  uploadTicketingProviderBtnId: string;
  uploadAscCostBtnId: string;
};

export const useAscDataSourceLayoutAnalyticIds = (): AscDataSourceLayoutAnalyticIds => ({
  uploadTicketingProviderBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_UPLOAD_TICKETING_PROVIDER_BUTTON),
  uploadAscCostBtnId: useAnalyticId(AnalyticIdentifier.DATA_SOURCES_UPLOAD_ASC_COST_BUTTON),
});
